import React, { useEffect, useRef, useState } from 'react';

const API_URL = '';

export default function DemoModeBanner() {
  const [state, setState] = useState(null);
  const bannerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/demo/status`)
      .then((r) => (r.ok ? r.json() : { demoMode: false }))
      .then((d) => {
        if (!cancelled) setState(d);
      })
      .catch(() => {
        if (!cancelled) setState({ demoMode: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Reserve layout height + offset fixed chrome; keep banner fixed + opaque so scroll does not show content through it.
  useEffect(() => {
    const root = document.documentElement;
    if (!state?.demoMode) {
      root.classList.remove('optiprime-demo-active');
      root.style.removeProperty('--optiprime-demo-banner-height');
      return undefined;
    }
    const apply = () => {
      const el = bannerRef.current;
      const h = el ? Math.ceil(el.getBoundingClientRect().height) : 48;
      root.style.setProperty('--optiprime-demo-banner-height', `${h}px`);
      root.classList.add('optiprime-demo-active');
    };
    apply();
    requestAnimationFrame(apply);
    window.addEventListener('resize', apply);
    return () => {
      window.removeEventListener('resize', apply);
      root.classList.remove('optiprime-demo-active');
      root.style.removeProperty('--optiprime-demo-banner-height');
    };
  }, [state?.demoMode, state?.bannerText]);

  if (!state?.demoMode) return null;

  return (
    <div
      ref={bannerRef}
      role="status"
      className="optiprime-demo-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px 16px',
        textAlign: 'center',
        fontSize: '0.9rem',
        fontWeight: 600,
        /* Solid base so page content never shows through when scrolling */
        backgroundColor: '#0f172a',
        backgroundImage: 'linear-gradient(90deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)',
        color: '#e0f2fe',
        borderBottom: '1px solid rgba(25, 239, 255, 0.22)',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.4)',
        zIndex: 10000,
        flexShrink: 0,
        pointerEvents: 'auto',
      }}
    >
      {state.bannerText || 'Demo mode — illustrative data only.'}
    </div>
  );
}
